<template>

    <div>
        <el-card shadow="hover"  class="searchCard" >
            <span class="label-span">
                <label class="label">月份</label>
                <el-date-picker style="width:200px"
                                v-model="query.countMonth"
                                type="month"
                                value-format="yyyy-MM"
                                placeholder="选择年月"
                                class="mr10">
                </el-date-picker>
            </span>
            <span class="label-span">
                <label class="label">上游资源</label>
                <el-select v-model="query.upid" placeholder="上游资源" filterable clearable
                           class="handle-select mr10">
                    <el-option value="" label="全部" />
                    <el-option v-for="item in selectData['channelOption']" :key="item.optKey" :label="item.optVal"
                               :value="item.optKey" />
                </el-select>
            </span>
            <span class="label-span">
                <label class="label">产品名称</label>
                <el-select v-model="query.goodsCode"  placeholder="产品名称" filterable  clearable style="width:300px;">
                    <el-option v-for="item in selectData['goodsOption2']" :key="item.optKey" :label="item.optVal" :value="item.optKey" />
                </el-select>
            </span>
            <el-button icon="el-icon-search" class='mr10' @click="handleSearch">搜索</el-button>
            <el-button icon="el-icon-refresh" class='mr10' @click="refreshSearch">重置</el-button>
            <el-button icon="el-icon-download" class='mr10' @click="downFinanceExcel">导出</el-button>
        </el-card>
        <el-card class="containCard">
            <div slot="header" class="clearfix">
                <span style="font-size:16px;"><span class="boomDanger">●</span>财务统计分析（公司管理 + 运营提成） </span>
                &nbsp;&nbsp;
                <el-tag effect="plain" size="medium" v-for="item of Object.values(queryTag)" v-if="item.show && item.value">{{item.name}}：{{item.value}}</el-tag>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <span style="font-size:15px;line-height:18px;color:#777;">
                    <b v-if="queryTag.goodsCode">{{queryTag.goodsCode.value}}</b>
                    预计<b :class="profitColor(profit.profitExpected)">{{profitText(profit.profitExpected)}}{{formatNumber(profit.profitExpected)}}元</b>
                    ，实际<b :class="profitColor(profit.profitActual)">{{profitText(profit.profitActual)}}{{formatNumber(profit.profitActual)}}元</b>
                </span>

            </div>
            <div class="text item" >
                <el-row :gutter="24">
                    <el-col :span="6">
                        <div class="card-container">
                            <el-card class="top-card"  style="height: 100px">
                                <div class="card-content">
                                    <i class="el-icon-lx-recharge icon danger_color"></i>
                                    <div class="text-content iconJump">
                                        <div class="card-value danger_color" v-animate-number="countSumData(['actualReceivable'])"></div>
                                        <div class="card-title">上游结算</div>
                                        <div class="card-title2">
                                            预收：<b v-animate-number="summariesData['accountsReceivable'].value['total']"/>
                                            &nbsp;&nbsp;
                                            实收：<b v-animate-number="summariesData['actualReceivable'].value['total']"/>
                                        </div>
                                    </div>
                                </div>
                            </el-card>
                            <div class="hover-layer"></div>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="card-container">
                            <el-card class="top-card"  style="height: 100px">
                                <div class="card-content">
                                    <i class="el-icon-lx-recharge icon warning_color"></i>
                                    <div class="text-content iconJump">
                                        <div class="card-value warning_color" v-animate-number="countSumData(['downSettlPrice','com','cost'])"></div>
                                        <div class="card-title">运营成本</div>
                                        <div class="card-title2" style="scale: 0.9">
                                            投放:<b v-animate-number="summariesData['downSettlPrice'].value['total']"/>
                                            &nbsp;&nbsp;
                                            商务:<b v-animate-number="summariesData['com'].value['total']"/>
                                            &nbsp;&nbsp;
                                            破解:<b v-animate-number="summariesData['cost'].value['pjCost']"/>
                                            &nbsp;&nbsp;
                                            税费:<b v-animate-number="summariesData['cost'].value['taxCost']"/>
                                        </div>
                                    </div>
                                </div>
                            </el-card>
                            <div class="hover-layer"></div>
                        </div>
                    </el-col>

                    <el-col :span="6">
                        <div class="card-container">
                            <el-card class="top-card"  style="height: 100px">
                                <div class="card-content">
                                    <i class="el-icon-lx-recharge icon primary_color"></i>
                                    <div class="text-content iconJump">
                                        <div class="card-value primary_color" v-animate-number="countSumData(['companyCost'])"></div>
                                        <div class="card-title">公司管理</div>
                                    </div>
                                </div>
                            </el-card>
                            <div class="hover-layer"></div>
                        </div>
                    </el-col>

                    <el-col :span="6">
                        <div class="card-container">
                            <el-card class="top-card"  style="height: 100px">
                                <div class="card-content">
                                    <i class="el-icon-lx-recharge icon success_color"></i>
                                    <div class="text-content iconJump">
                                        <div class="card-value success_color" v-animate-number="countSumData(['operBonus'])"></div>
                                        <div class="card-title">运营提成</div>
                                        <div class="card-title2">
                                            预计：<b v-animate-number="summariesData['operBonus'].value['operBonusExpected']"/>
                                            &nbsp;&nbsp;
                                            实际：<b v-animate-number="summariesData['operBonus'].value['operBonusActual']"/>
                                        </div>
                                    </div>
                                </div>
                            </el-card>
                            <div class="hover-layer"></div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <br>
            <br>
            <el-table :data="tableData" class="table" border ref="multipleTable" header-cell-class-name="table-header"
                      v-loading="tableLoading"  element-loading-text="" element-loading-spinner="el-icon-loading"
                      show-summary :summary-method="getSummaries" @expand-change="expandChange">
                <el-table-column type="expand" >
                    <template v-slot="props">
                        <el-card style="background-color: #eee">
                            <el-table :data="tableData2[props.row.id]" style="width: 53.1%;margin-left: 6.2%; margin-top: -15px; border-top: 1px solid #666"
                                      >
                                <el-table-column prop="memid" min-width="110" align="left" label="下游渠道">
                                    <template v-slot="scope">
                                        {{formatSelect('memberOption',scope.row.memid)}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="downCom" :min-width="250/2" align="left" label="下游商务成本"></el-table-column>
                                <el-table-column prop="otherCom" :min-width="250/2" align="left" label="下游杂费成本"></el-table-column>
                                <el-table-column prop="downSettlPricePaid" min-width="140" align="left" label="下游投放佣金(已付)"></el-table-column>
                                <el-table-column prop="downSettlPricePending" min-width="140" align="left" label="下游投放佣金(待付)"></el-table-column>
                                <el-table-column prop="fb1" min-width="110" align="left" label="核减">
                                    <template v-slot="scope">
                                        {{scope.row.fb1?scope.row.fb1:0}}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-card>
                    </template>
                </el-table-column>
                <el-table-column prop="countMonth" min-width="60" align="left" label="月份">
                </el-table-column>
                <el-table-column prop="upid" min-width="110" align="left" label="上游名称">
                    <template v-slot="scope">
                        {{formatSelect('channelOption',scope.row.upid)}}
                    </template>
                </el-table-column>
                <el-table-column prop="goods" min-width="250" align="left"  label="产品名称">
                    <template v-slot="scope">
                       {{ scope.row.goodsName }}&nbsp;({{ scope.row.goodsCode }})
                    </template>
                </el-table-column>
                <el-table-column prop="accountsReceivable" min-width="140" align="left"  label="应收账款">
                    <template v-slot="scope">
                        <p style="font-size:12px;line-height:18px;color:#777;">
                            {{scope.row.accountsReceivable}} 元
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="actualReceivable" min-width="140" align="left"  label="实收账款">
                    <template v-slot="scope">
                        <p style="font-size:12px;line-height:18px;color:#777;">
                            <input :id="'actual_'+scope.$index"  class='inputStyle danger_color' :class="!actualDisabledConfig[scope.$index]?'':'inputStyle_border'"
                                   :disabled="!actualDisabledConfig[scope.$index]"  v-model.trim="scope.row.actualReceivable"
                                   style="width:80px;margin-left:0;" placeholder="未录入" @blur="actualEditBlur(scope.$index)" @change="actualEditChange(scope.row)"/>
                            元 &nbsp;&nbsp;
                            <i class="el-icon-edit-outline blue" @click="actualChange(scope.row,scope.$index,'actual_'+scope.$index)" style="font-size:15px !important;"/>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="companyCost" min-width="110" align="left"  label="公司管理成本">
                    <template v-slot="scope">
                        <p style="font-size:12px;line-height:18px;color:#777;">
                            <b class='primary_color'>{{scope.row.companyCost}} 元</b>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="com" min-width="130" align="left"  label="商务提成">
                    <template v-slot="scope">
                        <p style="font-size:12px;line-height:18px;color:#777;">
                            上游提成：{{scope.row.upCom}} 元
                            <br>
                            下游提成：{{scope.row.downCom}} 元
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="cost" min-width="130" align="left"  label="杂费成本">
                    <template v-slot="scope">
                        <p style="font-size:12px;line-height:18px;color:#777;">
                            破解成本：{{scope.row.pjCost}} 元
                            <br>
                            税费成本：{{scope.row.taxCost}} 元
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="downSettlPrice" min-width="130" align="left"  label="下游投放佣金">
                    <template v-slot="scope">
                        <p style="font-size:12px;line-height:18px;color:#777;">
                            已付账款：{{scope.row.downSettlPricePaid}} 元
                            <br>
                            待付账款：<b class='warning_color'>{{scope.row.downSettlPricePending}} 元</b>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="operBonus" min-width="200" align="left"  label="运营提成">
                    <template v-slot="scope">
                        <p style="font-size:12px;line-height:18px;color:#777;">
                            预计：{{scope.row.operBonusExpected}} 元
                            <br>
                            实际：
                            <span v-if="!scope.row.actualReceivable" style="font-size:12px;color:#999;font-weight:700"><i class="red el-icon-lx-infofill"/>账单未完结 (核减:{{scope.row.fb1?scope.row.fb1:0}}元)</span>
                            <span v-if="scope.row.actualReceivable"><i class="green el-icon-success"/><b class='success_color'>{{scope.row.operBonusActual}} 元 (核减:{{scope.row.fb1?scope.row.fb1:0}}元)</b></span>
                        </p>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
    </div>
</template>

<script>

import $ from 'jquery' ;
import selectManager from '@/utils/selectUtils2';
import { changeActualForm, fetchAllData as financeList, downFinanceExcel } from '@/api/monthFinance.js';
import { fetchAllData as financeMemberList  } from '@/api/monthFinanceMember';
import { formatNumber } from '@/utils/toolUtiils';
import { getCurrentMonth } from '@/utils/dateUtils';
export default {
    data() {
        return {
            formatSelect:selectManager.formatSelect.bind(selectManager),
            query:{
                countMonth:getCurrentMonth(),
            },
            queryTag: {
                countMonth: {name: '月份', value: '', show: true },
                upid: {name: '上游', value: '', convert: 'channelOption', show: true },
                goodsCode: {name: '产品', value: '', convert: 'goodsOption2', show: false },
            },
            profit:{
                profitExpected:0,
                profitActual:0,
            },
            selectData:{},
            tableLoading:false,
            summariesData:{
                //  summariesData结构描述
                //  summariesData.key 对应table的prop属性
                //  summariesData.key.name prop可能对应个字段，这里配置字段名，为空则默认与prop字段名一致
                //  summariesData.key.totalName 需要汇总的字段名集合，为空则默认与summariesData.key.name一致
                //  summariesData.key.value 记录数据的汇总结果 ,total是所有totalName的和的和，另外会记录各个name字段的和，可通过name名获取
                //  summariesData.key.unit 数据单位,可以为空
                accountsReceivable:{
                    value:{total:0},
                    unit:"元"
                },
                actualReceivable:{
                    value:{total:0},
                    unit:"元"
                },
                companyCost:{
                    value:{total:0},
                    unit:"元"
                },
                com:{
                    name:['upCom','downCom'],
                    value:{total:0},
                    unit:"元"
                },
                cost:{
                    name:['pjCost','taxCost'],
                    value:{total:0},
                    unit:"元"
                },
                downSettlPrice:{
                    name:['downSettlPricePaid','downSettlPricePending'],
                    value:{total:0},
                    unit:"元"
                },
                operBonus:{
                    totalName:['operBonusActual'],
                    name:['operBonusExpected','operBonusActual'],
                    value:{total:0},
                    unit:"元"
                },
            },
            tableData: [],
            tableData2: {},
            totalData:{
                value:1000,
                companyCost:1000,
                operBonus:-501,
                operBonusExpected:500,
                operBonusActual:-1001,
            },
            actualDisabledConfig:{},

        };
    },
    created() {
        // 初始化工具类中的Vue实例
        selectManager.initialize(this,this.selectData);
        // 加载下拉框数据
        this.loadDropdownData();
    },
    //页面加载方法
    mounted: function () {
        //查询列表
        this.handleSearch();
    },

    methods: {
        formatNumber,
        loadDropdownData() {
            selectManager.getOption("channelOption");
            selectManager.getOption("memberOption");
            selectManager.getOption("goodsOption2");
        },
        // 触发搜索按钮
        handleSearch() {
            this.getData();
            Object.keys(this.queryTag).forEach(key=>{
                let item = this.queryTag[key];
                let value = this.query[key];
                if (item.convert){
                    value = this.formatSelect(item.convert,value,{def:"",defKeyValue:"",defValueValue:""});
                }
                this.$set(item,'value',value);
            })
        },
        //重置按钮
        refreshSearch(){
            this.$set(this,"query",this.$options.data().query);
            this.handleSearch();
        },

        queryCheck(action){
            if (!this.query.countMonth && !this.query.goodsCode){
                this.$message({
                    message: '请至少填写月份或产品编码中的一个',
                    type: 'warning'
                });
                return;
            }
            action({...this.query});
        },

        downFinanceExcel(){
            this.queryCheck(param=>{
                downFinanceExcel(param).then(res => {
                    this.loading = false
                    if(res.code=='200'){
                        this.$notify({ title: '成功', message: res.message,duration: 5000, type: 'success' });
                    }else{
                        this.$notify({ title: '失败', message: '后台下载异常',duration: 5000, type: 'error' });
                    }
                });
            })
        },

        //查询
        getData() {
            this.queryCheck(param=>{
                this.loading = true;
                financeList(param).then(res => {
                    //先将一些汇总的数据初始化
                    let data = this.$options.data();
                    this.$set(this,"summariesData",data.summariesData);
                    this.$set(this,"profit",data.profit);
                    this.loading = false;
                    if (res.code === '200') {
                        this.tableData = res.data;
                    } else {
                        this.tableData = [];
                    }
                });
            })
        },
        getTotalData(){
            this.$set(this.profit,"profitExpected",this.countSumData(["companyCost","operBonus-operBonusExpected"]));
            this.$set(this.profit,"profitActual",this.countSumData(["companyCost","operBonus-operBonusActual"]));
        },
        //row：当前点击行 对象
        //expandedRows：所有已展开的行 数组
        expandChange(row,expandedRows){
            // 判断当前行是否展开
            const isExpanded = expandedRows.some(item => item.id === row.id);
            if (!isExpanded){
                //关闭操作，不做处理
                return;
            }

            let param = {
                financeCode:row.financeCode
            };

            financeMemberList(param).then(res =>{
                if (res.code === '200') {
                    this.$set(this.tableData2,row.id,res.data);
                } else {
                    this.$set(this.tableData2,row.id,[]);
                }
            })
        },
        countSumData(keyArray){
            const values = [];
            keyArray.forEach(column=>{
                let columnArr = column.split("-")
                let sumData = this.summariesData[columnArr[0]];
                let valueName = columnArr.length> 1 && columnArr[1]?columnArr[1]:"total";
                values.push(sumData.value[valueName]);
            })
            let total = 0;
            if (!values.every(value => isNaN(value))) {
                total = values.reduce((prev, curr) => {
                    const value = Number(curr);
                    if (!isNaN(value)) {
                        return prev + curr;
                    } else {
                        return prev;
                    }
                }, 0);
            }

            return total;
        },
        getSummaries(param){
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总价';
                    return;
                }
                let sumData = this.summariesData[column.property];

                if (!sumData){
                    return;
                }
                sums[index] = 0;

                let name = sumData.name || [column.property];
                let totalName = sumData.totalName || name;
                name.forEach(columnName=>{
                    const values = data.map(item => Number(item[columnName]));
                    if (!values.every(value => isNaN(value))) {
                         let total = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sumData.value[columnName] = total;
                        if (totalName.indexOf(columnName)>-1){
                            sums[index] += total;
                        }
                    }
                })
                sumData.value['total'] = sums[index];
                sums[index] = formatNumber(sums[index]) + " " + (sumData.unit || "");
            });
            this.getTotalData();
            return sums;
        },
        //实收账款
        actualChange(row,index,inputId){
            if (!row.actualReceivable){
                this.$set(this.actualDisabledConfig,index,inputId);
                this.$nextTick(() => {
                    $('#'+inputId).focus();
                });
                return;
            }
            this.$confirm('此操作将重新计算运营实际提成, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$set(this.actualDisabledConfig,index,inputId);
                this.$nextTick(() => {
                    $('#'+inputId).focus();
                });
            }).catch(() => {
                this.$set(this.actualDisabledConfig,index,null);
            });
        },
        actualEditBlur(index){
            this.$set(this.actualDisabledConfig,index,null);
        },
        actualEditChange(row){
            changeActualForm(row).then((res)=>{
                this.handleSearch();
            })
        },
        profitText(amount) {
            return amount >= 0 ? '盈利' : '亏损';
        },
        profitColor(amount) {
            return amount >= 0 ? 'profitRed' : 'profitGreen';
        },
    }
};
</script>

<style scoped>
.inputStyle{
    height:28px;
    text-align:left;
    border:none;
    background: none;
    color:orange;
}

.inputStyle_border{
    border-bottom:1px solid orange;
}

.inputStyle::placeholder{
    color:#bbb;
}
.inputStyle:focus {
    outline:none;
    border-bottom:2px solid red;
}

.profitRed{
    color:red;
    font-size:16px;
}

.profitGreen{
    color:green;
    font-size:16px;
}


.card-container {
    width: 96%;
    margin: 0px 2%;
    position: relative;
    overflow: visible;
}

.top-card {
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 5px 0;
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 0.8);
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
    z-index: 2;
    position: relative;
}

.card-title {
    font-size: 17px !important;
    margin-top: 0; /* 移除顶部间距 */
    margin-left: 45px;
    text-align: center;
    color:#333 !important;
}

.card-title2 {
    font-size: 12px !important;
    margin-top: 5px; /* 移除顶部间距 */
    margin-left: 45px;
    text-align: center;
    color:#666;
}

.card-value {
    font-size: 25px !important;
    font-weight: bold;
    margin-top: 5px;
    margin-left: 45px;
    text-align: center;
    color: #333;
}

.hover-layer {
    border-radius: 10px;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, #7ebcfd, #7ebcfd);
    transform: scale(0);
    transform-origin: center center;
    opacity: 0.6;
    transition: all 0.4s ease-in-out;
    z-index: 1;
    pointer-events: none;
}

.card-container:hover .hover-layer {
    transform: scale(1);
    opacity: 1;
}
.card-value span {
    font-weight: normal;
}

.card-value .positive {
    color: #2ecc71; /* 鲜亮绿色，表示增长 */
}

.card-value .negative {
    color: #e74c3c; /* 鲜艳红色，表示下降 */
}


.icon {
    font-size: 70px !important;
    height: 100px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    vertical-align: middle;
    color: rgb(9, 169, 22) ;
    position: absolute;
    left:30px !important;
}
.card-content {
    display: flex;
    align-items: center;
}
.text-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center; /* 确保文本居中对齐 */
}
.no-border-row,.no-border-cell {
    border: none !important;
}
</style>
